import { createFileRoute } from '@tanstack/react-router'
import { DesaInfoManager } from '../../../../components/DesaInfoManager'

export const Route = createFileRoute('/platform/desa/$desaId/informasi')({
  component: () => {
    const { desaId } = Route.useParams()
    return <DesaInfoManager desaId={desaId} />
  },
})
